import React, { useState, useEffect } from 'react'
import { Text, Box } from '@deseretbook/react-ui'

/**
 * A small tooltip component that copies text to the clipboard when clicked.
 *
 * @param {object} props.textToCopy - The text to copy to the clipboard
 * @param {object} props.timeout - The time in milliseconds to display the tooltip
 * @param {object} props.children - The children to render
 *
 * @returns {function} Component
 */
const CopyTooltip = ({ textToCopy, timeout = 1500, children }) => {
  const [copied, setCopied] = useState(false)

  const handleClick = () => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setCopied(true)
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err)
      })
  }

  useEffect(() => {
    let timer
    if (copied) {
      timer = setTimeout(() => setCopied(false), timeout)
    }
    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [copied, timeout])

  const tooltipStyle = {
    position: 'absolute',
    top: '-35px',
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'grey',
    color: '#fff',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    visibility: copied ? 'visible' : 'hidden',
    transition: 'opacity 0.3s ease',
  }

  return (
    <Box style={{ position: 'relative' }}>
      {React.cloneElement(children, { onClick: handleClick })}
      <Text style={tooltipStyle}>Copied!</Text>
    </Box>
  )
}

export default CopyTooltip
